import apiClient from '../client'

export const complianceService = {
  getRemediations: async (websiteId, page = 1, limit = 10) => {
    const response = await apiClient.get(
      `/compliance/websites/${websiteId}/remediations?page=${page}&limit=${limit}`
    )
    const payload = response.data?.data ?? response.data
    if (Array.isArray(payload)) {
      return {
        data: payload,
        page,
        totalPages: 1,
        totalResults: payload.length,
      }
    }
    return payload
  },

  getComplianceReport: async (websiteId) => {
    const response = await apiClient.get(`/compliance/websites/${websiteId}/report`)
    return response.data?.data ?? response.data
  },

  downloadComplianceReportPdf: async (websiteId) => {
    const response = await apiClient.get(`/compliance/websites/${websiteId}/report/pdf`, {
      responseType: 'blob',
    })
    return response.data
  },
}
